/**
 * @description Usage <input value="world" auto-focus />
 */
;(function () {
  angular.module('contrast.form').directive('autoFocus', function () {
    return {
      link: {
        post: function postLink(scope, element) {
          // this succeeds since the element has been rendered
          element[0].focus()
        }
      }
    }
  })
})()
